import 'core/types/globals';

import { createRoot } from 'react-dom/client';

import App from 'com/App';

createRoot(
  orDie(document.getElementById('root')),
  import.meta.env.DEV
    ? {
        testMode: true,
        transformSource: source => ({
          ...source,
          fileName: source.fileName.replace(
            /^.+\/client/,
            'webpack://faiwer-wordcards-fe'
          ),
        }),
      }
    : undefined
).render(<App />);
